import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=773d2048&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('773d2048')) {
      api.createRecord('773d2048', component.options)
    } else {
      api.reload('773d2048', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=773d2048&", function () {
      api.rerender('773d2048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yR9JkEhu7ocM/JS/offershelp.vue"
export default component.exports